import React from "react";

//boostrap
import { Container, Row } from "reactstrap";

//components
import { LaunchModules } from "@components/weitzman";

function WeitzmanConfirmPage(props) {
  return (
    <div className="wrapper -loginPartnerPage">
      <div className="registerContainer">
        <Container>
          <Row className="align-items-center">
            <LaunchModules {...props} />
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default WeitzmanConfirmPage;